import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ChangePasswordService } from '../auth/change-password.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent implements OnInit {
  contentReady: boolean = false;
  changePasswordForm!: FormGroup;
  isAr: boolean = false;
  constructor(
    private _FormBuilder: FormBuilder,
    private _changePasswordService: ChangePasswordService,
    private _router: Router
  ) { }
  ngOnInit(): void {
    this.isAr = localStorage.getItem("language") == "ar";
    this.changePasswordForm = this._FormBuilder.group(
      {
        old_password: ['', Validators.required],
        new_password: ['', Validators.required],
        new_password_confirmation: ['', Validators.required],
      },
      { validator: this.validateAreEqual('new_password', 'new_password_confirmation') }
    );
  }

  onSubmit() {
    if (this.changePasswordForm.valid) {


      this._changePasswordService
        .resetPassword(
          this.changePasswordForm.value.old_password,
          this.changePasswordForm.value.new_password,
          this.changePasswordForm.value.new_password_confirmation
        )
        .subscribe({
          next: (res) => {
            Swal.fire({
              icon: 'success',
              title: this.isAr ? "كلمة السر اتغيرت" : 'password changed',
              showConfirmButton: false,
              timer: 1500,
            });
            this._router.navigateByUrl('/Profile');
          },
          error: (err) => {
            Swal.fire({
              icon: 'error',
              title: this.isAr ? "  البيانات اللي مدخلها فيها حاجة غلط " : 'Wrong Password',
              confirmButtonText: this.isAr ? 'تمام' : 'ok',
            });
          },
        });
    }
  }

  isPasswordVisible: boolean = false;
  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  validateAreEqual(pass: string, c_Pass: string) {
    return (group: FormGroup) => {
      const new_password = group.controls[pass];
      const new_password_confirmation = group.controls[c_Pass];
      if (new_password.value !== new_password_confirmation.value) {
        new_password_confirmation.setErrors({ passwordMismatch: true });
      } else {
        new_password_confirmation.setErrors(null);
      }
    };
  }
}
